// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__1mA6f","card_news":"style_card_news__2pOhX","view":"style_view__2P30E","card_body":"style_card_body__2gPJO","title":"style_title__1wtSZ","tag":"style_tag__3FXpT"};